import { useAuth0 } from "@auth0/auth0-react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Action from "components/ActionPopOver";
import MyModal from "components/MyModal";
import { formatDate } from "helper/dateFormat";
import { getCurrency, numberFormat } from "helper/numberFormat";
import React, { memo, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";
import { DateFormetContext } from "../../../app/App";
import { ModalCloseValue, SetSelectedBatchId } from "../../../app/redux/actions/index";
import FinanceService from "../../../Lib/API/Finance/index";
import ChargesTable from "../TransactionsTable";

const BatchBillingTableData = (props) => {
  const {
    row,
    /* check,
    onPayNowClick,
    onReversalClick,
    setDrawerData,
    setOpenModal,
    , */
    setPage,
    setFinanceTablePage,
    financeTablePage,
    page,
    handleClick,
    setBatchId,
    onEditNowClick,
    financeData,
    batchDataCount,
    setBatchDataCount,
    finance,
    batchId,
    modalOpen,
    chargedSorting,
    chargeSorting,
    setBatchList,
    batchList,
  } = props;
  const dispatch = useDispatch();
  const dateFormet = React.useContext(DateFormetContext);
  const initialFilters = {
    sort: {},
    search: undefined,
  };

  const currency = getCurrency();

  const [sortData, setSortData] = useState(initialFilters);

  const [expandRow, setExpandRow] = useState(false);
  const [open, setOpen] = React.useState(false);

  const [rowsPerPage, setRowsPerPage] = React.useState(30);
  const [filters, setFilters] = useState({});

  const { getAccessTokenSilently } = useAuth0();
  const [reversalActionTypes, setReversalActionTypes] = useState(false);
  const [getTypes, setActionTypes] = useState("");
  const [paymentId, setPaymentId] = useState();
  const [chargeId, setchargeId] = useState();
  const fetchReversalTypes = async (type, Id1, Id2) => {
    setchargeId(Id1);
    setPaymentId(Id2);
    const token = await getAccessTokenSilently();
    await FinanceService.getAllReversalTypes(type, token).then((res) => {
      setActionTypes(res?.result);
    }).catch((err) => {
      toastr.error("Error", err?.data?.message);
    });

    setReversalActionTypes(true);
  };
  const handleCloseDialog = () => {
    setReversalActionTypes(false);
  };

  const onModalClose = () => {
    setOpen(false);
    dispatch(SetSelectedBatchId(null));
    // window.location.reload();
  };

  useEffect(() => {
    // onModalClose();
  }, [batchList]);

  useEffect(() => {
    onEditNowClick({});
  }, []);
  // const openModel = () => {
  // setOpen(true);
  // };
  // const sortCharged = (e) => {
  //   setSortData((prev) => ({
  //     ...prev,
  //     sort: {
  //       [e]: prev.sort[e] === 1 ? -1 : 1,
  //     },
  //   }));
  // };
  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell component="th" scope="row">
          <div className="sub title-name">{row?.batch_name}</div>
        </TableCell>
        <TableCell align="left">
          <div className="sub">
            {numberFormat({ number: +row?.amount, decimal: 2, style: 'currency' })}
          </div>
        </TableCell>
        <TableCell align="left">
          <div
            className="sub"
            style={{ textDecoration: "underline", fontWeight: "800" }}
          >
            {row?.status}
          </div>
          {row?.updatedAt
            ? formatDate({ date: row?.updatedAt, formatType: "defaultWithUTC" })
            : ""}
        </TableCell>
        <TableCell align="left">
          <div className="sub">
            {row?.batch_type === "previous_amounts"
              ? "Previous Amount"
              : row?.batch_type === "manual"
                ? "Manual"
                : row?.batch_type === "file" ? "File" : "Account"}
          </div>
        </TableCell>
        <TableCell align="left">
          <div className="table-row">
            <p className="sub">{row?.organization?.orgName}</p>
            <div className="led">
              {row?.updatedAt
                ? formatDate({ date: row?.updatedAt, formatType: "defaultWithUTC" })
                : ""}
            </div>
          </div>
        </TableCell>
        <TableCell align="left">
          <div className="sub">
            {row?._id}
          </div>
        </TableCell>
        <TableCell align="left" className="sticky-body-column">
          <div
            style={{
              cursor: "pointer",
              paddingleft: "0px",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Action
              style={{ width: "16px" }}
              action="BatchBilling"
              id={row._id}
              status={row.status}
              page={page}
              setExpandRow={setExpandRow}
              handleClick={handleClick}
              handleBatchId={() => { setBatchId(row?._id); dispatch(SetSelectedBatchId({ data: row?._id, type: "batchId" })); dispatch(ModalCloseValue(false)) }}
              setOpen={setOpen}
              onEditNowClick={() => onEditNowClick(row)}
            />
          </div>
        </TableCell>
      </TableRow>

      <MyModal
        className="batch-charge-modal"
        open={open}
        onClose={onModalClose}
      >
        <div className="batch-table-modal" style={{
          maxWidth: '1000px'
        }}>
          <ChargesTable
            checkbatchBillingTable={true}
            batchbillingShow={true}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            setPage={setFinanceTablePage}
            // handleChangePage={handleChangePage}
            // handleChangeRowsPerPage={handleChangeRowsPerPage}
            list={financeData}
            batchDataCount={batchDataCount}
            setBatchDataCount={setBatchDataCount}
            finance={finance}
            filters={chargeSorting}
            page={financeTablePage ?? 0}
            sortCharged={chargedSorting}
            batchTable="batchtable"
            setBatchList={setBatchList}
            showTabs={false}
          />
        </div>
      </MyModal>
    </React.Fragment>
  );
};

export default memo(BatchBillingTableData);
